// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TargetSummary_QuadMain__4XD4K {
  box-sizing: border-box;
  width: 100%;
}

/* Create four equal columns that floats next to each other */
.TargetSummary_QuadColumn__OGCMt {
  float: left;
  width: 50%;
  padding: 10px;
  min-height: 300px; /* Should be removed. Only for demonstration */
}

/* Clear floats after the columns */
.TargetSummary_QuadRow__kIzf3:after {
  content: "";
  display: table;
  clear: both;
}
`, "",{"version":3,"sources":["webpack://./src/scene-d/Target/TargetView/TargetSummary/TargetSummary.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA,6DAA6D;AAC7D;EACE,WAAW;EACX,UAAU;EACV,aAAa;EACb,iBAAiB,EAAE,8CAA8C;AACnE;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb","sourcesContent":[".QuadMain {\n  box-sizing: border-box;\n  width: 100%;\n}\n\n/* Create four equal columns that floats next to each other */\n.QuadColumn {\n  float: left;\n  width: 50%;\n  padding: 10px;\n  min-height: 300px; /* Should be removed. Only for demonstration */\n}\n\n/* Clear floats after the columns */\n.QuadRow:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"QuadMain": `TargetSummary_QuadMain__4XD4K`,
	"QuadColumn": `TargetSummary_QuadColumn__OGCMt`,
	"QuadRow": `TargetSummary_QuadRow__kIzf3`
};
export default ___CSS_LOADER_EXPORT___;
